import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import icClose from 'assets/svg/ic_close_V2.svg';
import PageContent from '@profile/src/Components/PageContent';
import Spinner from '@profile/src/Components/Spinner';
import { AppError } from '@profile/src/redux/types';
import { formatErrorMessage } from '../utils';
import { updateProfile } from '@profile/src/redux/actions';
import { useTypedSelector, useTypedDispatch } from '@profile/src/redux/utils';
import Modal from '@profile/src/Components/Modal';

const UpdateNameModal = ({
  onClose
}) => {
  const dispatch = useTypedDispatch();
  const loading = useTypedSelector(state => state.updateProfile.loading);
  const invalidated = useTypedSelector(state => state.updateProfile.invalidated);
  const error = useTypedSelector(state => state.updateProfile.error);
  const [errorCode, setErrorCode] = React.useState(error);
  const [input, setInput] = React.useState('');
  React.useEffect(() => {
    setErrorCode(error);
  }, [error]);

  const isValid = () => {
    if (!input) {
      setErrorCode(AppError.NAME_INVALID);
      return false;
    }

    return true;
  };

  const onSubmit = () => {
    if (isValid()) {
      dispatch(updateProfile()); //update in phase 2
    }
  };

  const renderModal = () => /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "CHANGE NAME"), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: styles.close
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "Enter your new username. ", /*#__PURE__*/React.createElement("br", null), "You can change your username", ' ', /*#__PURE__*/React.createElement("span", {
    className: styles.highlight
  }, "ONLY ONCE")), /*#__PURE__*/React.createElement("label", {
    htmlFor: "input-name",
    className: styles.inputLabel
  }, "Name"), /*#__PURE__*/React.createElement("input", {
    id: "input-name",
    onChange: e => {
      setInput(e.target.value);
    },
    placeholder: 'Enter your name',
    className: classNames(styles.input, error && styles.error),
    type: "text"
  }), errorCode !== AppError.NO_ERROR && /*#__PURE__*/React.createElement("span", {
    className: styles.errorMessage
  }, formatErrorMessage(errorCode)), /*#__PURE__*/React.createElement("button", {
    disabled: loading,
    onClick: onSubmit,
    className: classNames(styles.button, styles.primary, loading && styles.disabled)
  }, loading ? /*#__PURE__*/React.createElement(Spinner, {
    size: 24,
    className: styles.loading
  }) : 'Apply'))));

  return /*#__PURE__*/React.createElement(PageContent, {
    invalidated: invalidated,
    loading: loading,
    error: errorCode !== AppError.NO_ERROR,
    renderContent: renderModal,
    renderLoading: renderModal,
    renderError: renderModal
  });
};

export default UpdateNameModal;